import React, { useEffect, useState } from "react";
import { Table, Row, Col, Card, Divider, Form, Input, Button, notification, Modal, message, Select } from "antd";
import { useParams } from "react-router-dom";
import { loadingClient } from "../../../services";
import dayjs from "dayjs";

const { Meta } = Card;

function ViewLoadingPlan() {

  const { id } = useParams();
  const [form] = Form.useForm();
  const [data, setData] = useState({});
  const [customer, setCustomer] = useState([]);
  const [loading, setLoading] = useState(false);
  const [vehicles, setVehicles] = useState([])
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [otherReason, setOtherReason] = useState("");

  const apiUrl = process.env.REACT_APP_API_URL;

  const fieldData = [
    { label: "Container ID", value: data?.container_id },
    { label: "Destination", value: data?.destination },
    { label: "Shipping Line", value: data?.shipping_line },
    { label: "ERD Date", value: data?.erd_date },

    { label: "ETD Date", value: data?.etd_date },
    {
      label: "Title Cut Off",
      value: dayjs(data?.title_cut_off).format("YYYY-MM-DD"),
    },
    {
      label: "Cargo Cut Off ",
      value: dayjs(data?.cargo_cut_off).format("YYYY-MM-DD"),
    },
    {
      label: "Document File",
      value: (() => {
        const fileUrl = data?.file ? `${apiUrl}/${data.file}` : null;
        if (!fileUrl) return "-";

        const isImage = /\.(jpg|jpeg|png|gif)$/i.test(fileUrl);
        return isImage ? (
          <img
            src={fileUrl}
            alt="File"
            style={{ width: "70px", height: "50px", objectFit: "contain", borderRadius: "4px" }}
          />
        ) : (
          <a href={fileUrl} target="_blank" rel="noopener noreferrer">
            View File
          </a>
        );
      })(),
    },
    { label: "ETA Date", value: data?.eta_date },
    { label: "Location", value: data?.location },
    {
      label: "Booking Type",
      value: data?.is_dg == 1 ? "DG" : "NON-DG",
    },
    { label: "Container Size", value: data?.container_size },
    { label: "Booking Number", value: data?.c_booking_number },
    {
      label: "Auto Cut Off",
      value: dayjs(data?.auto_cut_off).format("YYYY-MM-DD"),
    },
    {
      label: "Doc Cut Off",
      value: dayjs(data?.doc_cut_off).format("YYYY-MM-DD"),
    },
    {
      label: "Doc Cut Off",
      value: dayjs(data?.doc_cut_off).format("YYYY-MM-DD"),
    },
  ];

  const columns = [
    {
      title: "S.no",
      dataIndex: "S.no",
      key: "S.no",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "Year",
    },
    {
      title: "Make",
      dataIndex: "product",
      key: "Make",
    },
    {
      title: "Model",
      dataIndex: "product",
      key: "Model",
    },
    {
      title: "Vin #",
      dataIndex: "chasis_no",
      key: "Vin ",
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "Title",
    },
    {
      title: "Title State",
      dataIndex: "title_state",
      key: "TitleState",
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "Value",
    },
    {
      title: "Weight",
      dataIndex: "weight",
      key: "Weight",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
    },
    {
      title: "Image",
      dataIndex: "images",
      key: "Image",
      render: (text, record) => (
        <img
          src={record?.images?.[0]?.url || ""} // URL of the image
          alt="Vehicle"
          style={{
            width: "70px",
            height: "50px",
            objectFit: "contain",
            borderRadius: "4px",
          }}
        />
      ),
    },
  ];

  const handleConfirm = async () => {
    setLoading(true);
    const payload = {
      mainid: id,     // container id from useParams
      status: 1
    };
    const res = await loadingClient.confirmRequest(payload);
    setLoading(false);
    if (res.success) {
      notification.success("Load Plan Confirmed Successfully");
      initialize();   // reload page with updated status
    }
    else {
      notification.error("Something went wrong");
    }
  };

  const handleRejectSubmit = async () => {
    if (!rejectReason) {
      message.error("Please select a reason");
      return;
    }
    setLoading(true);
    const payload = {
      mainid: id,
      remarks: rejectReason,
      other: rejectReason === "other" ? otherReason : null
    };
    const res = await loadingClient.rejectRequest(payload);
    setLoading(false);

    if (res.success) {
      notification.success("Load Plan Rejected Successfully");
      setRejectModalOpen(false);
      initialize();   // refresh page
    }
    else {
      notification.error("Error rejecting load plan");
    }
  };

  const initialize = async () => {
    try {
      setLoading(true);
      const { success, data, message } = await loadingClient.View(id);
      if (success) {
        setData(data);
        setVehicles(data?.vehicles)
        setCustomer(data.customer);
        form.setFieldsValue({
          special_note: data?.client_loading_note,
          update_note: data?.client_loading_update_note,
        });
      } else {
        console.error(`Error: ${message || "Failed to fetch client details."}`);
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    initialize();
  }, []);

  const options = [
    { value: "container unavailable", label: "Container Unavailable" },
    { value: "wooden floor not available", label: "Wooden Floor Not Available" },
    { value: "delay from customer", label: "Delay From Customer" },
    { value: "other", label: "Other" },
  ]

  const rejectModal = (
    <Modal
      title="Reject Load Plan"
      open={rejectModalOpen}
      onCancel={() => setRejectModalOpen(false)}
      onOk={handleRejectSubmit}
      okText="Submit"
      confirmLoading={loading}
    >
      <Select
        value={rejectReason}
        onChange={(value) => setRejectReason(value)}
        style={{ width: "100%", marginBottom: 12, height: "45px" }}
        placeholder="Select Reason"
        size="large"
      >
        {options.map((opt, index) => (
          <Select.Option value={opt.value} key={index}>
            {opt.label}
          </Select.Option>
        ))}
      </Select>


      {rejectReason === "other" && (
        <Input.TextArea
          rows={4}
          placeholder="Enter your custom reason..."
          value={otherReason}
          onChange={(e) => setOtherReason(e.target.value)}
        />
      )}
    </Modal>

  )

  return (
    <>
      <Row gutter={24} wrap={false}>
        {/* First Column */}
        <Col flex="370px">
          <Card style={{ padding: "12px" }}>
            {/* First Section: Name and Email */}
            <Meta title={customer?.name || "N/A"} style={{ textAlign: "center" }} />
            <div style={{ marginTop: "10px", textAlign: "center" }}>
              <p> {customer?.email || "N/A"}</p>
            </div>
            <Divider />
            <div className="profile-info">
              <p>
                <strong>Phone:</strong> {customer?.phone || "N/A"}
              </p>
              <p>
                <strong>Address:</strong> {customer?.address || "N/A"}
              </p>
              <p>
                <strong>Town:</strong> {customer?.town || "N/A"}
              </p>
              <p>
                <strong>City:</strong> {customer?.city || "N/A"}
              </p>
              <p>
                <strong>Country:</strong> {customer?.country_name || "N/A"}
              </p>
              <p>
                <strong>Secondary Email:</strong>
                {customer?.secondary_email
                  ? customer?.secondary_email
                  : "-----------"}
              </p>
            </div>
            <Divider />
            {data?.is_client_approved_loadplan === 0 && data?.reject === 0 ?
              <div className="flex gap-3">
                <Button type='primary' onClick={() => setRejectModalOpen(true)} loading={loading}>
                  Reject
                </Button>
                <Button type='primary' onClick={handleConfirm} loading={loading} >
                  Confirm
                </Button>
              </div>
              : data?.is_client_approved_loadplan === 1 ?
                <p className="text-green-600 text-center"> Booking plan request has been approved</p> :
                data?.reject === 1 ?
                  <p className="text-red-600 text-center"> Booking has been rejected</p> : null
            }
          </Card>
        </Col>

        <Col flex="1">
          <div
            style={{
              padding: "15px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              backgroundColor: "#FFFFFF",
            }}
          >
            <Row gutter={12}>
              <Col span={12}>
                <h1 style={{ fontWeight: "bold" }}>View Details</h1>
              </Col>
            </Row>

            <Table
              columns={columns}
              scroll={{ x: "max-content" }}
              dataSource={vehicles}
              style={{ marginTop: "10px" }}
              loading={loading}
              pagination={false}
            />
          </div>

          <div
            style={{
              padding: "15px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              backgroundColor: "#FFFFFF",
              marginTop: "20px",
            }}
          >
            <Row gutter={12}>
              <Col span={12}>
                <h1 style={{ fontWeight: "bold" }}>Load Plan Details</h1>
              </Col>
            </Row>
            <Row gutter={24} className="mt-3">
              {fieldData.map((field, index) => (
                <Col key={field.id || index} span={12}>
                  <div
                    style={{
                      display: "flex",
                      width: 310,
                      border: "1px solid #d9d9d9",
                      borderRadius: 4,
                      marginBottom: 2,
                    }}
                  >
                    <div
                      style={{
                        flex: 1,
                        padding: "4px 11px",
                        backgroundColor: "#f5f5f5",
                        borderRight: "1px solid #d9d9d9",
                      }}
                    >
                      {field.label}
                    </div>
                    <p
                      style={{
                        flex: 1,
                        margin: 0,
                        padding: "4px 11px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {field.value}
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
          </div>

          <Form
            requiredMark={false}
            layout="vertical"
            form={form}
            initialValues={{ layout: "vertical" }}
            className="mt-5"
          >
            <Row gutter={24} align="bottom">
              <Col span={12}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: "bold" }}>Special Note:</span>
                  }
                  name="special_note"
                >
                  <Input.TextArea
                    placeholder="Enter special notes here..."
                    rows={5}
                  />
                </Form.Item>
              </Col>

              <Col span={12} style={{ textAlign: "right" }}>
                <Form.Item
                  label={
                    <span style={{ fontWeight: "bold" }}>Updation Note:</span>
                  }
                  name="update_note"
                >
                  <Input.TextArea
                    placeholder="Enter special notes here..."
                    rows={5}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>

          {/* <Row gutter={24} className="mb-5">
            <Col span={24}>
              <div
                style={{
                  display: "flex",
                  width: 695,
                  border: "1px solid #d9d9d9",
                  borderRadius: 10,
                  marginBottom: 2,
                }}
              >
                <div
                  style={{
                    flex: 0.5,
                    padding: "4px 11px",
                    color: "#b91111",
                    border: "1px solid #b91111",
                    borderRadius: 5,

                    // backgroundColor: "#b91111",
                    borderRight: "1px solid #b91111",
                  }}
                >
                  Booking has been rejected
                </div>
                <p
                  style={{
                    flex: 1.5,
                    margin: 0,
                    padding: "4px 11px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Reason: Container unavailability / wooden floor not available
                  at the port.
                </p>
              </div>
            </Col>
          </Row> */}
        </Col>
      </Row>
      {rejectModal}
      <style>
        {`
  .profile-info {
    display: flex;
    flex-direction: column; /* Stack items vertically */
    gap: 15px; /* Space between each <p> element */
  }

  .profile-info p {
    display: flex; /* Makes each <p> a flex container */
     justify-content:space-between;
  }

  .profile-info strong {
    margin-right: 25px; /* Space between <strong> and <p> content */
    width: 100px; /* You can adjust this value to ensure equal space between all labels */
    text-align: left; /* Optional: Align the <strong> to the left */
  }
`}
      </style>
    </>
  );
}

export default ViewLoadingPlan;
